<template>
  <div class="create">
    <info-panel :padding="24">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item
              label="理论考试须知"
              prop="questionExamPurchaseNotice"
            >
              <!-- <el-input
                v-model="createForm.questionExamPurchaseNotice"
                type="textarea"
              /> -->
              <editor :html.sync="createForm.questionExamPurchaseNotice" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axClient from '@/services';
import infoPanel from '@/components/common/infoPanel.vue';
import Editor from '@/components/common/editor.vue';

export default {
  name: 'AgencyEdit',
  components: {
    infoPanel,
    Editor,
  },
  data() {
    return {
      createForm: {
        questionExamPurchaseNotice: '',
      },
      creatRules: {
        questionExamPurchaseNotice: [
          { required: false, message: '请输入理论考试须知', trigger: 'blur' },
        ],
      },
      isEditType: !!this.$route.params.id,
    };
  },
  mounted() {
    this.isEdit();
  },
  methods: {
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.config.updateQuestionExamPurchaseNotice(this.createForm);
          if (data) {
            this.$message.success('编辑理论考试须知成功');
            this.$router.push({ name: 'ConfigQuestionExam' });
          }
        }
      });
    },
    // 是否编辑信息
    async isEdit() {
      const { questionExamPurchaseNotice } = await axClient.config.getQuestionExamPurchaseNotice();
      this.createForm = {
        questionExamPurchaseNotice,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 20px;
  text-align: center;
}
</style>